/**
 * Azure AD MSAL Configuration
 * For Redbull Liberty Support Agent Dashboard
 */

export const msalConfig = {
  auth: {
    clientId: "63f4b7c0-3fda-44d1-9e6c-9749c47975bd",
    authority: "https://login.microsoftonline.com/a01b3b4a-1448-4fe9-b967-00927abe0460",
    redirectUri: process.env.REACT_APP_REDIRECT_URI || "http://localhost:3001/auth/callback",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case 0: // Error
            console.error(message);
            return;
          case 1: // Warning
            console.warn(message);
            return;
          case 2: // Info
            console.info(message);
            return;
          case 3: // Verbose
            console.debug(message);
            return;
          default:
            return;
        }
      }
    }
  }
};

export const loginRequest = {
  scopes: ["User.Read", "email", "profile", "openid"]
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};

